import { $getFiltersRequestType } from '@shared/types';
import { z } from 'zod';

export const $CandidateRequestParams = $getFiltersRequestType(z.object({}));
